// extracted by mini-css-extract-plugin
module.exports = {"root":"Work_root___z0PA","projectsContainer":"Work_projectsContainer__mvlS1","techContainer":"Work_techContainer__YYrbM","partners":"Work_partners__54a1O"};